import {TeamSeason} from '../resources/TeamSeason';
import {DomainEvent} from './DomainEvent';

export class TeamSeasonImageUpdated extends DomainEvent<TeamSeason> {}
